export enum Chef {
  MASTERCHEF,
  MASTERCHEF_V2,
  MINICHEF,
  OLD_FARMS,
}

export enum Rewarder {
  SIMPLE,
  COMPLEX,
  ALCX,
}

export enum PairType {
  SWAP,
  KASHI,
}
